import { useMediaQuery } from '@vueuse/core'

/**
 * 响应式断点工具
 *
 * 统一项目内的移动端判定逻辑，所有组件/页面都应当通过这个 composable
 * 读取 isMobile / isTablet / isDesktop，而不是各自写 window.matchMedia 或
 * 硬编码 @media 查询中的 768px。
 *
 * 断点约定（与 styles/mixins.scss 保持一致）：
 *   mobile  : <= 768px
 *   tablet  : 769px ~ 1400px
 *   desktop : >  1400px
 */
export function useResponsive() {
  // 注意：useMediaQuery 返回的是 ref，模板里会自动 unwrap
  const isMobile = useMediaQuery('(max-width: 768px)')
  const isTablet = useMediaQuery('(min-width: 769px) and (max-width: 1400px)')
  const isDesktop = useMediaQuery('(min-width: 1401px)')

  // 便捷组合：小于等于平板（用于"非桌面端"统一降级）
  const isTabletOrSmaller = useMediaQuery('(max-width: 1400px)')

  return {
    isMobile,
    isTablet,
    isDesktop,
    isTabletOrSmaller
  }
}
